<!--
 * @Descripttion: 登录页面组件 - 支持密码登录和验证码登录
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-19 10:14:30
--> 

<template>
  <div class="login">
    <div>
      <el-card class="box-card" shadow="hover">
        <router-link class="login-logo-link" to="/">
          <img class="login-logo" src="../assets/imgs/logo.svg" alt />
        </router-link>
        <div class="clearfix">
          <span>Login</span>
        </div>
        <!-- 登录方式切换 -->
        <div class="login-tabs">
          <span
            class="tab-item"
            :class="{ active: loginMode === 'password' }"
            @click="switchMode('password')"
          >Password</span>
          <span class="tab-divider">|</span>
          <span
            class="tab-item"
            :class="{ active: loginMode === 'email' }"
            @click="switchMode('email')"
          >Email</span>
          <span class="tab-divider">|</span>
          <span
            class="tab-item"
            :class="{ active: loginMode === 'otp' }"
            @click="switchMode('otp')"
          >OTP</span>
        </div>

        <!-- 密码登录 -->
        <div class="item" v-if="loginMode === 'password'">
          <el-form :model="pwdForm" status-icon :rules="pwdRules" ref="pwdForm">
            <el-form-item prop="user_name">
              <el-input v-model="pwdForm.user_name" placeholder="Username, Email or Phone"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="pwdForm.password" placeholder="Password"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="loginByPassword('pwdForm')">Login</a>
          </div>
          <el-link
            type="primary"
            href="/#/register"
            style="float:right;margin-bottom:10px;"
          >Don't have an account? Please register first ></el-link>
        </div>

        <!-- 邮箱验证码登录 -->
        <div class="item" v-if="loginMode === 'email'">
          <el-form :model="emailForm" status-icon :rules="emailRules" ref="emailForm">
            <el-form-item prop="email">
              <el-input v-model="emailForm.email" placeholder="Email address"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="emailForm.code" placeholder="Verification code">
                <template slot="append">
                  <el-button
                    :disabled="emailCounting"
                    @click="sendEmailOTP"
                    style="padding:10px 8px;font-size:12px;"
                  >{{ emailBtnText }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="loginByEmail('emailForm')">Login / Register</a>
          </div>
          <el-link
            type="primary"
            href="/#/register"
            style="float:right;margin-bottom:10px;"
          >Don't have an account? Please register first ></el-link>
        </div>

        <!-- OTP验证码登录 -->
        <div class="item" v-if="loginMode === 'otp'">
          <el-form :model="otpForm" status-icon :rules="otpRules" ref="otpForm">
            <el-form-item prop="phone">
              <el-input v-model="otpForm.phone" placeholder="Phone number"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="otpForm.code" placeholder="Verification code">
                <template slot="append">
                  <el-button
                    :disabled="smsCounting"
                    @click="sendOTP"
                    style="padding:10px 8px;font-size:12px;"
                  >{{ smsBtnText }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="loginByOTP('otpForm')">Login / Register</a>
          </div>
          <el-link
            type="primary"
            href="/#/register"
            style="float:right;margin-bottom:10px;"
          >Don't have an account? Please register first ></el-link>
        </div>

        <div class="line"></div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'

export default {
  name: 'Login',
  data() {
    var validateUser = function(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter username, email or phone'))
      } else if (value.length < 5 || value.length > 50) {
        callback(new Error('Length should be between 5 and 50'))
      }
      callback()
    }
    var validatePass = function(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('The password length should be between 6 and 16'))
      }
      callback()
    }
    var validatePhone = function(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter phone number'))
      } else if (!/^[0-9]{7,15}$/.test(value)) {
        callback(new Error('Please enter a valid phone number'))
      }
      callback()
    }
    var validateCode = function(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter verification code'))
      } else if (!/^[0-9]{6}$/.test(value)) {
        callback(new Error('Please enter a 6-digit verification code'))
      }
      callback()
    }
    var validateEmail = function(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter email address'))
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error('Please enter a valid email address'))
      }
      callback()
    }
    return {
      loginMode: 'password',
      pwdForm: {
        user_name: '',
        password: ''
      },
      emailForm: {
        email: '',
        code: ''
      },
      otpForm: {
        phone: '',
        code: ''
      },
      pwdRules: {
        user_name: [{ validator: validateUser, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }]
      },
      emailRules: {
        email: [{ validator: validateEmail, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      otpRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      smsCounting: false,
      smsCountdown: 60,
      smsBtnText: 'Send OTP',
      emailCounting: false,
      emailCountdown: 60,
      emailBtnText: 'Send Code'
    }
  },
  methods: {
    ...mapActions(['setUser']),
    switchMode(mode) {
      this.loginMode = mode
    },
    handleLoginSuccess(res) {
      if (res.status === 200) {
        var user = JSON.stringify(res.data.user)
        localStorage.setItem('user', user)
        localStorage.setItem('token', res.data.token)
        this.setUser(res.data.user)
        this.notifySucceed('Login successful')
        this.$router.push({ name: 'Home' })
      } else {
        this.notifyError('Login failed', res.msg)
      }
    },
    loginByPassword(formName) {
      var self = this
      this.$refs[formName].validate(function(valid) {
        if (!valid) { return }
        userAPI.postLogin(self.pwdForm)
          .then(function(res) {
            self.handleLoginSuccess(res)
          })
          .catch(function(error) {
            self.notifyError('Login failed', error)
          })
      })
    },
    sendOTP() {
      var self = this
      var phoneVal = this.otpForm.phone
      if (!phoneVal || !/^[0-9]{7,15}$/.test(phoneVal)) {
        this.notifyError('Invalid phone', 'Please enter a valid phone number')
        return
      }
      this.smsCounting = true
      this.smsBtnText = this.smsCountdown + 's'
      var timer = setInterval(function() {
        self.smsCountdown--
        self.smsBtnText = self.smsCountdown + 's'
        if (self.smsCountdown <= 0) {
          clearInterval(timer)
          self.smsCounting = false
          self.smsCountdown = 60
          self.smsBtnText = 'Send OTP'
        }
      }, 1000)

      userAPI.sendSMSCode(phoneVal)
        .then(function(res) {
          if (res.status === 200) {
            self.notifySucceed('Verification code sent')
          } else {
            self.notifyError('Failed to send', res.msg)
          }
        })
        .catch(function(error) {
          self.notifyError('Failed to send', error)
        })
    },
    loginByOTP(formName) {
      var self = this
      this.$refs[formName].validate(function(valid) {
        if (!valid) { return }
        userAPI.smsLogin(self.otpForm)
          .then(function(res) {
            self.handleLoginSuccess(res)
          })
          .catch(function(error) {
            self.notifyError('Login failed', error)
          })
      })
    },
    sendEmailOTP() {
      var self = this
      var emailVal = this.emailForm.email
      if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        this.notifyError('Invalid email', 'Please enter a valid email address')
        return
      }
      this.emailCounting = true
      this.emailBtnText = this.emailCountdown + 's'
      var timer = setInterval(function() {
        self.emailCountdown--
        self.emailBtnText = self.emailCountdown + 's'
        if (self.emailCountdown <= 0) {
          clearInterval(timer)
          self.emailCounting = false
          self.emailCountdown = 60
          self.emailBtnText = 'Send Code'
        }
      }, 1000)

      userAPI.sendEmailCode(emailVal)
        .then(function(res) {
          if (res.status === 200) {
            self.notifySucceed('Verification code sent to your email')
          } else {
            self.notifyError('Failed to send', res.msg)
          }
        })
        .catch(function(error) {
          self.notifyError('Failed to send', error)
        })
    },
    loginByEmail(formName) {
      var self = this
      this.$refs[formName].validate(function(valid) {
        if (!valid) { return }
        userAPI.emailLogin(self.emailForm)
          .then(function(res) {
            self.handleLoginSuccess(res)
          })
          .catch(function(error) {
            self.notifyError('Login failed', error)
          })
      })
    }
  }
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}
.item {
  margin: 0 auto;
  width: 300px;
}
.clearfix {
  font-size: 20px;
  margin-bottom: 10px;
}
.login-tabs {
  margin-bottom: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.tab-item {
  cursor: pointer;
  font-size: 15px;
  color: #999;
  transition: color 0.2s;
}
.tab-item.active {
  color: #B9365B;
  font-weight: 600;
}
.tab-divider {
  color: #ccc;
}
.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 300px;
  border-radius: 10px;
}
.login-logo-link {
  display: flex;
  justify-content: center;
}
.login-logo {
  width: 120px;
  height: auto;
}
.box-card .line {
  height: 30px;
  width: 300px;
  margin: 0 auto;
  border-bottom: 1px solid #c0c0c0;
}
</style>
